export const SEC_BP:string = 'bp';
export const SEC_BP_ACCESS_SETTINGS:string = 'bp-access-settings';
export const SEC_BP_ACCREDITATIONS:string = 'bp-accreditations';
export const SEC_BP_ACSL_INFO:string = 'bp-acsl-info';
export const SEC_BP_ACTIVEACSLUSERS:string = 'bp-activeacslusers';
export const SEC_BP_BANK:string = 'bp-bank';
export const SEC_BP_CATALOG:string = 'bp-catalog';
export const SEC_BP_CAVEATS:string = 'bp-caveats';
export const SEC_BP_CONTACTS:string = 'bp-contacts';
export const SEC_BP_CONTRACT:string = 'bp-contract';
export const SEC_BP_DASHBOARD_BP:string = 'bp-dashboard-bp';
export const SEC_BP_DASHBOARD_ORDER:string = 'bp-dashboard-order';
export const SEC_BP_DOCUMENTS:string = 'bp-documents';
export const SEC_BP_GENERAL:string = 'bp-general';
export const SEC_BP_INVOICE_TEMPLATES:string = 'bp-invoice-templates';
export const SEC_BP_LBDM_CHECKLIST:string = 'bp-lbdm-checklist';
export const SEC_BP_LOCATIONS:string = 'bp-locations';
export const SEC_BP_MAILS:string = 'bp-mails';
export const SEC_BP_OEM:string = 'bp-oem';
export const SEC_BP_PROFILE_CHECKLIST:string = 'bp-profile-checklist';
export const SEC_BP_SLA:string = 'bp-sla';
export const SEC_BP_TC:string = 'bp-tc';
export const SEC_BP_TERRITORIES:string = 'bp-territories';
export const SEC_BP_TICKETS:string = 'bp-tickets';
export const SEC_GLOBALPRODUCT_PRODUCT:string = 'globalproduct-product';
export const SEC_BP_PRODUCT_CATALOG:string = 'bp-product-catalog';

export const SEC_WS_ACCESS:string = 'ws-access';
export const SEC_WS_CATALOGSYNC:string = 'ws-catalogsync';
export const SEC_WS_GENERAL:string = 'ws-general';
export const SEC_WS_INFO:string = 'ws-info';
export const SEC_WS_INFO_GBDM:string = 'ws-info.gbdm';
export const SEC_WS_INFO_ACCOUNT_MANAGEMENT:string = 'ws-info.accountmanagement';
export const SEC_WS_INFO_LAMTYPE:string = 'ws-info.lamtype';
export const SEC_WS_INFO_LAMSIGNUP:string = 'ws-info.lam-signup';
export const SEC_WS_INFO_WS_NAME_AND_TYPE:string = 'ws-info.wsnameandtype';
export const SEC_WS_INVOICE:string = 'ws-invoice';
export const SEC_WS_RECREATEGENERICUSERS:string = 'ws-recreategenericusers';
export const SEC_WS_ROLE:string = 'ws-role';

// webshop billing
export const SEC_WS_BILLING:string = 'ws-invoice';
export const SEC_WS_BILLINGTYPE:string = 'ws-invoice.billingtype';
export const SEC_WS_CONTRACTTEMPLATE:string = 'ws-invoice.contracttemplate';
export const SEC_WS_BILLINGCONTRACT:string = 'ws-invoice.billingcontract';
export const SEC_WS_ADDRESS:string = 'ws-invoice.address';
export const SEC_WS_COMPLIANCE:string = 'ws-invoice.compliance';
export const SEC_WS_PAYMENTTERMS:string = 'ws-invoice.paymentterms';
export const SEC_WS_PAYMENTMODE:string = 'ws-invoice.paymentmode';
export const SEC_WS_MINCLEARINGSTATE:string = 'ws-invoice.minclearingstate';
export const SEC_WS_LEASING:string = 'ws-invoice.leasing';
export const SEC_WS_B2B:string = 'ws-invoice.b2b';
export const SEC_WS_CHARGEBACK:string = 'ws-invoice.chargeback';
export const SEC_WS_BATCHBILLING:string = 'ws-invoice.batchbill';
export const SEC_WS_SPENDLIMIT:string = 'ws-invoice.spendlimit';

// webshop supplier managemenet
export const SEC_WS_SUPPLIER:string = 'ws-supplier';
export const SEC_WS_GEOMATCH:string = 'ws-supplier.geomatch';
export const SEC_WS_SERVICETICKET:string = 'ws-supplier.serviceticket';
export const SEC_WS_MANAGEMENT:string = 'ws-supplier.management';
export const SEC_WS_BPACTIVATION:string = 'ws-supplier.bpactivation';
export const SEC_WS_BPSETUPCONDITIONS:string = 'ws-supplier.bpsetupconditions';
export const SEC_WS_INACTIVEBPS:string = 'ws-supplier.inactivebps';

// webshop b2b settings
export const SEC_WS_B2BSETTINGS:string = 'ws-b2bsettings';

//send FAQ
export const SEC_SEND_FAQ:string = 'faq-send';

